import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default class ErrorBoundary extends React.Component {
    state = { hasError: false };
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return _jsx("h1", { children: "Something went wrong." });
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map